'use strict';

var SceneTitle = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneTitle ()
  {
    Phaser.Scene.call(this, { key: 'sceneTitle', active: false });
  },

  init: function(params){
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'sceneTitle';

    this.sceneBoot.scaleMode = 'height';
    this.scaler.scaleMode = 'height';

    this.scene.bringToTop();
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    this.scene.setVisible(false);

    // designX = 0;
    // designY = 0;
    // sprite = this.add.rectangle(
    //   this.scaler.scaleX(this.scaler.designRefWidth()/2 + designX),
    //   this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
    //   this.scaler.designRefWidth(),
    //   this.scaler.designRefHeight()
    //   , 0xffffff, 1);
    // sprite.setOrigin(0.5, 0.5);
    // this.scaler.scaleSpriteFill(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   fill: true,
    //   xlocation: 'center',
    //   ylocation: 'center',
    //   designX: designX,
    //   designY: designY
    // };
    // this.bgSprite = sprite;
    // this.bgSprite.visible = false;
    
    designX = window.sidebarOffset;
    designY = 0;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX),
      this.scaler.scaleY(designY),
      'title'
    );
    sprite.setOrigin(0, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'left',
      ylocation: 'top',
      designX: designX,
      designY: designY,
      offset: 'x',
      initialX: 0,
    };    
  },

  update: function() {
  },

  resized: function () {
    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.keepData.offset == 'x') {
          s.keepData.designX = s.keepData.initialX + window.sidebarOffset;
        }
        
        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else{
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else{
            this.scaler.scaleSprite(s);
          }

          if(s.keepData.width){
            s.displayWidth = s.keepData.width * this.scaler.vScale();
          }
          if(s.keepData.height){
            s.displayHeight = s.keepData.height * this.scaler.vScale();
          }
        }
      }
    }
  },

  enterAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;

    this.tweens.add({
      targets: this.cameras.main,
      zoom: {
        start: 0,
        to: 1,
      },
      alpha: {
        start: 0,
        to: 1,
      },
      duration: duration,
      delay: 0,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    }); 
  },

  outAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;

    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });

    this.tweens.add({
      targets: this.cameras.main,
      alpha: 0,
      duration: duration,
      delay: 0,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        var phaserElements = self.children.list;
        phaserElements.forEach(sprite => {
          if(sprite.keepData.resized == false) {
            sprite.keepData.resized = true;
          }
        });
      },
    }); 
  },
});
export default SceneTitle;